module.exports = __webpack_public_path__ + "static/src/content/images/processed/800/background.981f4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/800/background.jpg
// module id = PICT
// module chunks = 1